import React from 'react'

 const Clients = () => {
  return (
    <>
        <div className='main-client'>
        <div className='client-sec'>
      <div className='sec-1'><i class="fa-regular fa-thumbs-up"></i><h2>200</h2><h5>Happy Clients</h5></div>
      <div className='sec-1'><i class="fa-solid fa-laptop-file"></i><h2>150</h2><h5>Finished Projects</h5></div>
      <div className='sec-1'><i class="fa-solid fa-person-chalkboard"></i><h2>24/7</h2><h5>Customer Support</h5></div>
      <div className='sec-1'><i class="fa-regular fa-address-card"></i><h2>Free </h2><h5>Consultation</h5></div>

        </div>
        </div>
    </>
  )
}
export default Clients;